/****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import * as async from 'async';


@Component({
    selector: 'dynamic-component-loader',
    templateUrl: './dynamic-component-loader.component.html',
    styleUrls: ['./dynamic-component-loader.component.scss'],
    standalone: false
})
export class DynamicComponentLoaderComponent implements OnInit {

  @Input() screenId: number;
  @Input() type: string;
  @Input() screenCode: string;
  @Input() uniqueId: any;
  @Input() dynamicParameters: any;
  templateDraggable = false;
  templateData: any;
  showSpinner: boolean = true;
  flexibleTemplate: boolean = false;

  @ViewChild('templateHolder', { read: ViewContainerRef, static: false }) viewContainerRef: ViewContainerRef;
  @ViewChild('templateLibrary', { read: ViewContainerRef, static: false }) templateViewContainerRef: ViewContainerRef;
  @ViewChild('componentLibrary', { read: ViewContainerRef, static: false }) componentViewContainerRef: ViewContainerRef;

  constructor(
    private commonService: CommonService) {
  }

  ngOnInit() {
    this.flexibleTemplate = false;
    this.showSpinner = true;
    var self = this;
    this.templateData = undefined;

    self.commonService.getScreen(self.screenId, self.screenCode, true, this.type).toPromise().then((response) => {
      if (response) {
        if (response.allowedTemplates && response.allowedTemplates.length) {
          async.eachSeries(response.allowedTemplates, function (template: any, templateCb) {
            self.commonService.createDynamicComponent(null, template.templateName, self.templateViewContainerRef, function (err, containerRef) {
              if (err) {
                return templateCb(err);
              }
              (<any>containerRef.instance).templateDraggable = true;
              (<any>containerRef.instance).viewOnly = false;
              (<any>containerRef.instance).flexibleTemplate = true;
              templateCb();
            });
          });
        }
        if (response.allowedComponents && response.allowedComponents.length) {
          this.flexibleTemplate = true;
          async.eachSeries(response.allowedComponents, function (component: any, componentCb) {
            self.commonService.createDynamicComponent(null, 'dynamic-wrapper', self.componentViewContainerRef, function (err, containerRef) {
              if (err) {
                return componentCb(err);
              }
              (<any>containerRef.instance).moduleName = component.module;
              (<any>containerRef.instance).componentName = component.name;
              (<any>containerRef.instance).displayName = component.displayName;
              (<any>containerRef.instance).viewOnly = false;
              if (component.staticParameters) {
                (<any>containerRef.instance).staticParameters = component.staticParameters;
              }
              if (self.dynamicParameters) {
                (<any>containerRef.instance).dynamicParameters = self.dynamicParameters;
              }
              componentCb();
            });
          }, function (err) {
            self.handleTemplateResponse(response);
          });
        } else {
          self.handleTemplateResponse(response);
        }
      } else {
        this.showSpinner = false;
      }
    }).catch((error) => {
      this.showSpinner = false;
      console.log(error);
    });
  }

  changeTemplateDesign() {
    this.templateDraggable = true;
    this.constructScreen(true);
  }

  freezeTemplate() {
    this.templateDraggable = false;
    this.constructScreen(false);
  }

  handleTemplateResponse(response) {
    if (response) {
      this.templateData = response;
      if (this.templateData.layout) {
        if (this.templateData.layout.length) {
          this.freezeTemplate();
        } else {
          //this.changeTemplateDesign();
        }
      } else {
        this.templateData.layout = [];
      }
    } else {
      this.templateData = {
        screenId: this.screenId,
        layout: []
      };
      //this.changeTemplateDesign();
    }
    this.showSpinner = false;
  }

  saveScreen() {
    this.showSpinner = true;
    this.commonService.saveScreen({
      seqId: this.screenId,
      screenId: this.templateData.screenId,
      type : this.type,
      layout: this.templateData.layout,
    }).toPromise().then((response) => {
      this.handleTemplateResponse(response);
      this.commonService.openSnackBar("Layout saved successfully");
    }).catch((error) => {
      console.log(error);
    });
  }

  constructScreen(templateChange) {
    this.viewContainerRef.clear();
    var self = this;
    if (this.templateData) {
      if (this.templateData.layout) {
        async.eachSeries(this.templateData.layout, function (element: any, elementCb) {
          self.commonService.createDynamicComponent(null, element.templateName, self.viewContainerRef, function (err, containerRef) {
            if (err) {
              return elementCb(err);
            }
            (<any>containerRef.instance).screenId = self.uniqueId + '_' + self.screenId + '_' + self.templateData.screenId;
            (<any>containerRef.instance).viewRef = containerRef.hostView;
            (<any>containerRef.instance).parentViewRef = self.viewContainerRef;
            (<any>containerRef.instance).templateDraggable = templateChange;
            (<any>containerRef.instance).elementDetail = element;
            (<any>containerRef.instance).viewOnly = false;
            (<any>containerRef.instance).flexibleTemplate = self.flexibleTemplate;
            if (self.dynamicParameters) {
              (<any>containerRef.instance).dynamicParameters = self.dynamicParameters;
            }
            (<any>containerRef.instance).remove.subscribe(data => {
              self.removeElement(data, self);
            });
            containerRef.changeDetectorRef.detectChanges();
            if (!templateChange) {
              (<any>containerRef.instance).constructScreen();
            }
            elementCb();
          });
        });
      }
    }
  }

  removeElement(data, self) {
    let rIndex = data.parentViewRef.indexOf(data.viewRef)
    data.parentViewRef.remove(rIndex);
    self.templateData.layout.splice(rIndex, 1);
  }

  dropTemplate(event) {
    event.preventDefault();
    if (!this.templateDraggable) {
      return;
    }
    if (event.dataTransfer.getData("component")) {
      return;
    }

    var temp = null;

    if (event.dataTransfer.getData("dynamicComponent")) {
      let index = event.dataTransfer.getData("index");
      this.viewContainerRef.remove(index);
      temp = this.templateData.layout[index];
      this.templateData.layout.splice(index, 1);
    }

    var insertIndex = 0;
    var heightSum = 0;
    for (var i = 0; i < this.viewContainerRef.length; i++) {
      let height = (<any>this.viewContainerRef).get(i).rootNodes[0].clientHeight;
      if (event.layerY >= heightSum && event.layerY < heightSum + height) {
        break;
      } else {
        insertIndex++;
        heightSum += height;
      }
    }

    let templateName = event.dataTransfer.getData("templateComponent");

    var self = this;
    this.commonService.createDynamicComponent(null, templateName, this.viewContainerRef, function (err, containerRef) {
      (<any>containerRef.instance).viewRef = containerRef.hostView;
      (<any>containerRef.instance).parentViewRef = self.viewContainerRef;
      (<any>containerRef.instance).templateDraggable = self.templateDraggable;
      (<any>containerRef.instance).viewOnly = false;
      (<any>containerRef.instance).flexibleTemplate = self.flexibleTemplate;
      (<any>containerRef.instance).screenId = self.uniqueId + '_' + self.screenId + '_' + self.templateData.screenId;
      if (self.dynamicParameters) {
        (<any>containerRef.instance).dynamicParameters = self.dynamicParameters;
      }
      (<any>containerRef.instance).remove.subscribe(data => {
        self.removeElement(data, self);
      });
      if (temp) {
        self.templateData.layout.splice(insertIndex, 0, temp);
      } else {
        self.templateData.layout.splice(insertIndex, 0, {
          templateName: templateName,
          boxDetails: []
        });
      }
    });
  }

  allowDrop(event) {
    event.preventDefault();
  }
}


